import { Component } from "@angular/core";

@Component({
  selector: 'msh-about-us',
  imports: [],
  template: `
    <div class="flex justify-center">
      <div class=" max-w-[1200px] mx-12 my-12">
        <div class="text-3xl font-bold mb-6">About Us</div>
        <div class="text-copy mb-4">
          Mobile Storehouse is dedicated to providing a seamless and enjoyable shopping experience for restaurant owners and franchisees. Our platform connects buyers and sellers, ensuring you always have a place for those extra items for when you need them.
        </div>
        <div class="text-copy mb-4">
          Founded in 2026, Mobile Storehouse hopes to be the premier marketplace for restaurant owners and franchisees. Our team is passionate about technology and committed to helping customers find the perfect products to meet their needs.
        </div>
        <div class="text-copy mb-4">
          We believe in transparency, customer satisfaction, and continuous innovation. Our goal is to make dealing with excess small wares and equipment easy, while also making it affordable when you need it.
        </div>
        <div class="text-copy mb-4">
          Thank you for choosing Mobile Storehouse. We look forward to serving you and helping you stay connected with the latest in mobile technology.
        </div>
      </div>
    </div>
  `,
  styles: ``
})
export class AboutUsComponent {

}